import { render, staticRenderFns } from "./twoside.vue?vue&type=template&id=0b355b82"
import script from "./twoside.vue?vue&type=script&lang=js"
export * from "./twoside.vue?vue&type=script&lang=js"
import style0 from "./twoside.vue?vue&type=style&index=0&id=0b355b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports